// Rendu du corps d'un message : liens # internes + URLs cliquables.
// Cohabite avec emojiShortcodes (qui agit à l'envoi, MessageComposer).
// Retour Julien 2026-06-01 : les "https://..." doivent rester intacts
// ET être cliquables (nouvel onglet). Les liens # naviguent dans l'app.
import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/cn';
import { hashLinkLabel, hashLinkPath, splitMessageBody } from '../../lib/messaging/hashLink';

interface Props {
  body: string;
  isOwn: boolean;
}

export function MessageBody({ body, isOwn }: Props) {
  const parts = splitMessageBody(body);
  const linkClass = cn(
    'underline break-all',
    isOwn ? 'text-white hover:text-white/80' : 'text-cime-primary hover:opacity-80',
  );

  return (
    <>
      {parts.map((p, i) => {
        if (p.type === 'text') return <Fragment key={i}>{p.value}</Fragment>;
        if (p.type === 'hash') {
          return (
            <Link
              key={i}
              to={hashLinkPath(p)}
              onClick={(e) => e.stopPropagation()}
              className={linkClass}
            >
              {hashLinkLabel(p.title)}
            </Link>
          );
        }
        const href = p.value.startsWith('http') ? p.value : `https://${p.value}`;
        return (
          <a
            key={i}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={(e) => e.stopPropagation()}
            className={linkClass}
          >
            {p.value}
          </a>
        );
      })}
    </>
  );
}
